import { UnitObject } from "@common/types/tree-types";
import json from "./unece-to-opcua.json";

export class UnitRepository {
  public getUnits(): UnitObject[] {
    return json;
  }
}
